import { AxiosInstance } from "axios";
import { IResponseBody } from "../../Schemas/EndPoint";
import { PbxTrunkSchema } from "../../Schemas/PbxTrunk";

export interface PbxTrunkResponseBody extends IResponseBody {
  data: {
    pbx_trunk: PbxTrunkSchema;
  };
}

interface PbxTrunkCreateRequestBody {
  workspace_id: null | number;
  pbx_server_id: number;
  pbx_trunk_reference: string;
  caption: string;
  description: string;
  status: string;
}

export class PbxTrunkUpdateRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath(id: number) {
    return `/admin/pbx-trunks/${id}/update`;
  }

  async send(
    serverId: number,
    contactCreateBody: PbxTrunkCreateRequestBody
  ): Promise<PbxTrunkResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath(serverId),
        contactCreateBody
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
